<template>
  <div class="pay-result-container c:col-center" v-show="showSuccess">
    <img class="cussess-icon" src="@/assets/icons/pay-success.svg" alt="" />
    <div class="success-text">支付成功，请返回微信</div>
  </div>
</template>
<script>
import { getCustomerOrderDetail } from "@/api";

export default {
  data() {
    return {
      orderDetail: {},
      showSuccess: true,
    };
  },
  methods: {
    getOrderDetail() {
      getCustomerOrderDetail(this.$route.query.orderNo).then((data) => {
        this.orderDetail = data;
        this.checkPayResult();
      });
    },
    checkPayResult() {
      if (Number(this.orderDetail.status) > 10) {
        this.showSuccess = true;
      }
    },
  },
  mounted() {
    // this.getOrderDetail()
  },
};
</script>
<style lang="less">
.pay-result-container {
  height: var(--dynamic-vh);
  .cussess-icon {
    width: 40/20rem;
    height: 40/20rem;
  }
  .success-text {
    font-size: 12px;
    font-weight: 600;
    margin-top: 1rem;
  }
}
</style>
